import type { ZarzDzanieSkrytkamiService } from '@coig/apm-api';

export class LockerManagementMockService implements ZarzDzanieSkrytkamiService {

  static mockService() {
    return true;
  }

  static async openParcelLocker(lockers: { requestBody: { compartmentIds?: number[] } }) {
    return {
      statusCode: 0,
      statusText: 'OK',
    };
  }
}
